// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badge {
  cursor: pointer;
  touch-action: manipulation;
}

.badge.circle {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  position: absolute;
  top: -5px;
  right: -5px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
  z-index: 10;
}

.badge.circle .pulse-element {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  animation: pulse 1.5s infinite ease-in-out;
  z-index: 11;
}

.badge.rectangle {
  width: 55px;
  height: 18px;
  border-radius: var(--border-radius-base);
  transition: all 0.3s ease;
  position: absolute;
  top: -5px;
  right: -35px;
  transform-origin: left center;
}

.badge.rectangle .pulse-element {
  display: none;
}

.badge-text {
  opacity: 0;
  white-space: nowrap;
  font-size: var(--font-size-tiny);
  letter-spacing: 0.028rem;
}

@media (max-width: 768px) {
  .badge.circle {
    width: 20px;
    height: 20px;
  }
  .badge.rectangle {
    width: 55px;
    height: 20px;
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.5);
    opacity: 1;
  }
  75% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(0.5);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/base/badge.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF","sourcesContent":[".badge {\n  cursor: pointer;\n  touch-action: manipulation;\n}\n\n.badge.circle {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: all 0.3s ease;\n  z-index: 10;\n}\n\n.badge.circle .pulse-element {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  animation: pulse 1.5s infinite ease-in-out;\n  z-index: 11;\n}\n\n.badge.rectangle {\n  width: 55px;\n  height: 18px;\n  border-radius: var(--border-radius-base);\n  transition: all 0.3s ease;\n  position: absolute;\n  top: -5px;\n  right: -35px;\n  transform-origin: left center;\n}\n\n.badge.rectangle .pulse-element {\n  display: none;\n}\n\n.badge-text {\n  opacity: 0;\n  white-space: nowrap;\n  font-size: var(--font-size-tiny);\n  letter-spacing: 0.028rem;\n}\n\n@media (max-width: 768px) {\n  .badge.circle {\n    width: 20px;\n    height: 20px;\n  }\n  .badge.rectangle {\n    width: 55px;\n    height: 20px;\n  }\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(0.5);\n    opacity: 1;\n  }\n  75% {\n    transform: scale(0.9);\n  }\n  100% {\n    transform: scale(0.5);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
